import { AuthenticationService } from '../_services';
import { LocalStorageKey } from "../_models/constants/local-storage";
import { EMPTY, of } from "rxjs";
import { catchError } from "rxjs/operators";
import {EnvService} from '../_services/configurations/env.service';

export function appInitializer(authenticationService: AuthenticationService) {
   const menu = localStorage.getItem(LocalStorageKey.menu);
   if (menu === null) {
      $('body').addClass('hold-transition login-page skin-blue sidebar-mini sidebar-mini sidebar-collapse');
   } else if (menu === 'ok') {
      $('body').addClass('hold-transition login-page skin-blue sidebar-mini sidebar-mini sidebar-collapse');
   } else {
      $('body').addClass('hold-transition login-page skin-blue sidebar-mini sidebar-mini ');
   }

   const user = localStorage.getItem('user');

   if (!user) {
      return () => EMPTY;
   }

   return () => authenticationService.refreshToken(JSON.parse(localStorage.getItem('user')).refreshToken).pipe(catchError(err => of(err)));
}

export function appInitializeEnv(envService: EnvService) {
   const menu = localStorage.getItem(LocalStorageKey.menu);
   if (menu === null) {
      $('body').addClass('hold-transition login-page skin-blue sidebar-mini sidebar-mini sidebar-collapse');
   } else if (menu === 'ok') {
      $('body').addClass('hold-transition login-page skin-blue sidebar-mini sidebar-mini sidebar-collapse');
   } else {
      $('body').addClass('hold-transition login-page skin-blue sidebar-mini sidebar-mini ');
   }
   return () => {
      return envService.setConfig();
   };
}
